<template>
    <div class="component-wrap">
        <van-dropdown-menu>
            <van-dropdown-item :title="currentCountyName" ref="dropdownMenu">
                <div class="area_content">
                    <div class="fc-tips" style="padding-bottom: 10px;padding-top: 27px;">区域</div>
                    <div class="area_list">
                        <span v-for="(item, index) in countyList" :key="index" class="txt-ellipsis" :class="currentCountyName === item.name ? 'active' : ''" @click="selectCounty(item)">
                            {{item.name}}
                        </span>
                    </div>
                </div>
            </van-dropdown-item>
            <van-dropdown-item :title="currentHallName" ref="dropdownMenu2">
                <div class="area_content">
                    <div class="fc-tips fx-row fx-between" style="padding-bottom: 10px;padding-top: 27px;">
                        <span>影厅</span>
                        <van-icon name="delete-o" size="20" @click="clearHall"></van-icon>
                    </div>
                    <div class="area_list">
                        <span v-for="(item, index) in specialHallList" :key="index" class="txt-ellipsis" :class="item.active ? 'active' : ''" @click="toggleHall(item, index)">
                            {{item.name}}
                        </span>
                    </div>
                </div>
            </van-dropdown-item>
            <!-- <van-dropdown-item title="综合排序">
                <div class="area-content">123</div>
            </van-dropdown-item> -->
        </van-dropdown-menu>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getCountyList, getSpecialHallList } from '@api/permission-request'
import { filter} from 'lodash'
export default {
    data() {
        return {
            countyList: [],
            specialHallList: [],
            originShList: [],
            // extendIcon: [
            //     require("./static/extend_grey.png"),
            //     require("./static/collapse_red.png"),
            // ]
        }
    },
    watch: {
        'currentCityCode': {
            handler() {
                this.getCountyList();
            }
        }
    },
    mounted() {
        this.getCountyList();
        this.getSpecialHallList();
    },
    methods: {
        selectCounty(item) {
            if (this.currentCountyName !== item.name) {
                this.$store.commit('setSelectedCounty', item);
                this.$emit('change', true);
                this.$refs.dropdownMenu.toggle(false);
            }
        },
        getCountyList() {
            let params = {
                cityCode: this.currentCityCode
            }
            getCountyList(params).then((res) => {
                res.list.unshift({ name: '全城' })
                this.countyList = res.list;
            })
        },
        getSpecialHallList() {
            getSpecialHallList().then((res) => {
                this.originShList = res;
                this.specialHallList = Object.assign([], this.originShList);
            })
        },
        toggleHall(item, index) {
            this.specialHallList = Object.assign([], this.originShList)
            this.$set(this.specialHallList, index, { ...item, active: true });
            this.$store.commit('setSelectedHall', item);
            this.$emit('change', 'hall')
            this.$refs.dropdownMenu2.toggle(false);
        },
        clearHall() {
            this.specialHallList = Object.assign([], this.originShList);
            this.$store.commit('setSelectedHall', {});
            this.$emit('change', 'hall')
            this.$refs.dropdownMenu2.toggle(false);

        }
    },
    computed: {
        ...mapGetters([
            'currentCityCode',
            'currentCountyName',
            'currentHallCode',
        ]),
        currentHallName() {
            let res = filter(this.specialHallList, ['id', this.currentHallCode])
            return res && res.length > 0 ? res[0].name : '筛选';
        }
    },
    beforeDestroy() {
        // console.log('销毁了组件')
        // this.$store.commit('setSelectedCounty', null);
    }
}
</script>

<style lang="scss" scoped>
.component-wrap {
	background-color: #fff;
	color: #3f4956;
	border-top: 1px solid #eff1f8;
	/deep/ .van-dropdown-menu__title {
		font-size: 12px;
		padding: 0 15px;
		&::after {
			border-color: transparent transparent #3d4957 #3d4957;
			right: 0;
		}
	}
	/deep/ .van-dropdown-menu__bar {
		box-shadow: 0px 0px 0px;
		height: 40px;
		.van-dropdown-menu__item {
			justify-content: start;
		}
	}
	.area_content {
		padding: 12px;
		.area_list {
			display: grid;
			grid-template-columns: repeat(3, 30%);
			justify-content: space-between;
			span {
				width: 100px;
				height: 30px;
				line-height: 30px;
				padding: 0 10px;
				background-color: #f5f5f7;
				color: #333;
				border-radius: 4px;
				text-align: center;
				margin: 8px 0;
			}
			span.active {
				color: #f4657d;
				background-color: #fff5f5;
			}
		}
	}
}
</style>
